// extracted by mini-css-extract-plugin
export var header = "intro-module--header--382Lh";
export var block = "intro-module--block--171EJ";
export var backBox = "intro-module--backBox--9RbYK";
export var backTitle = "intro-module--backTitle--146QO";
export var backIcon = "intro-module--backIcon--3kM0V";
export var container = "intro-module--container--1Zq7l";
export var spinner = "intro-module--spinner--24j73";
export var show = "intro-module--show--2GeJR";
export var stay = "intro-module--stay--VPZTN";
export var stayBasic = "intro-module--stayBasic--32qov";
export var stayUl = "intro-module--stayUl--2i4gB";
export var pText = "intro-module--pText--1SWZQ";
export var p = "intro-module--p--16RwA";
export var callIcon = "intro-module--callIcon--1t4-q";
export var triggerIcon = "intro-module--triggerIcon--1G7ap";
export var carIcon = "intro-module--carIcon--2I3KX";
export var forgivnessIcon = "intro-module--forgivnessIcon--VzUG9";
export var homeIcon = "intro-module--homeIcon--ZED-f";
export var insuranceIcon = "intro-module--insuranceIcon--3sb4Z";
export var iconHome = "intro-module--iconHome--3aYA4";
export var iconMedical = "intro-module--iconMedical--3xxSp";
export var iconFire = "intro-module--iconFire--1gF1m";
export var tapIcon = "intro-module--tapIcon--2Fq59";
export var stayUlFrom = "intro-module--stayUlFrom--i_ef5";
export var modalStyle = "intro-module--modalStyle--g6wWO";
export var newIntroduce = "intro-module--newIntroduce--17OD0";
export var gongGe = "intro-module--gongGe--29R8J";
export var interests = "intro-module--interests--3b6Lm";
export var choose = "intro-module--choose--jITHW";
export var tips = "intro-module--tips--3EvI5";
export var banner = "intro-module--banner--K9zzb";
export var sty = "intro-module--sty--2zSRz";
export var planSwitch = "intro-module--planSwitch--2b-Mj";
export var planBenefits = "intro-module--planBenefits--3HCL8";
export var reliable = "intro-module--reliable--1DWgm";
export var reliableWraper = "intro-module--reliableWraper--1JCeU";
export var secodes = "intro-module--secodes--ihbg4";
export var basicPlan = "intro-module--basicPlan--bCfSI";
export var plusPlan = "intro-module--plusPlan--35f7O";
export var comparion = "intro-module--comparion--luOTt";
export var hows = "intro-module--hows--35OwP";
export var howsWraper = "intro-module--howsWraper--3LHPL";
export var htwsText = "intro-module--htwsText--wNCLM";
export var tabWrapper = "intro-module--tabWrapper--2vn7f";
export var connected = "intro-module--connected--9P2ug";
export var userReviews = "intro-module--userReviews--2mIC5";
export var faq = "intro-module--faq--4SiwH";
export var faqWraper = "intro-module--faqWraper--364-s";
export var floating = "intro-module--floating--1tQkK";
export var floatingTip = "intro-module--floatingTip--1RmyW";
export var floatingBody = "intro-module--floatingBody--V8jkQ";
export var floatingEmpty = "intro-module--floatingEmpty--1aeBo";
export var floatingDemo = "intro-module--floatingDemo--3p9KI";
export var floatingStart = "intro-module--floatingStart--1iZqo";
export var floatingStartLoading = "intro-module--floatingStartLoading--xuTeu";
export var popupBtn = "intro-module--popupBtn--1raiK";
export var btnCancel = "intro-module--btnCancel--3BksE";
export var BackToTop = "intro-module--BackToTop--1mXhZ";
export var Top = "intro-module--Top--dy5oD";
export var Visible = "intro-module--Visible--68KBt";
export var Plan = "intro-module--Plan--1n2-O";
export var PlanChoice = "intro-module--PlanChoice--cf6GA";
export var PlanChoiceHeader = "intro-module--PlanChoiceHeader--3NmL6";
export var PlanTitle = "intro-module--PlanTitle--1px33";
export var DiscountBadge = "intro-module--DiscountBadge--31k3_";
export var PlanChoiceBody = "intro-module--PlanChoiceBody--2SX79";
export var PriceCurrent = "intro-module--PriceCurrent--3qsho";
export var PriceOriginal = "intro-module--PriceOriginal--2mz8F";
export var Discount = "intro-module--Discount--2WOmG";
export var Active = "intro-module--Active--22Uhc";
export var NorBanner = "intro-module--NorBanner--3uDbH";
export var BannerImg = "intro-module--BannerImg--1o4tU";
export var BannerText = "intro-module--BannerText--Cwd9I";
export var clause = "intro-module--clause--2ryrv";